<template>
    <div>
        <Modal
            v-model="showModal"
            draggable
            sticky
            title="Leave Request"
            width="560"
            footer-hide
            :closable="closable"
            class="viewTimeDispute"
            :before-close="handleReset"
        >
            <div class="request-view">
                <div class="request-view__head">
                    <span :class="['request-status', `request-status--${getLeaveStatus(form)}`]">
                        <span class="request-status__dot" />{{ formatStatus(getLeaveStatus(form)) }}
                    </span>
                    <span class="request-view__muted">Filed {{ formatDate(form.createdAt) }}</span>
                </div>

                <dl class="request-view__grid">
                    <template v-if="isAdmin">
                        <dt>Employee</dt>
                        <dd>
                            <template v-if="form.user && form.user.name">{{ form.user.name }}</template>
                            <UserList v-else :user="form.user && form.user._id" list-disabled />
                        </dd>
                    </template>

                    <dt>Leave Type</dt>
                    <dd>{{ formatLeaveType(form.requestedData && form.requestedData.type) }}</dd>

                    <dt>Leave Mode</dt>
                    <dd>{{ formatMode(form.requestedData && form.requestedData.mode) }}</dd>

                    <dt>Start Date</dt>
                    <dd>{{ formatDate(form.requestedStart) }}</dd>

                    <dt>End Date</dt>
                    <dd>{{ formatDate(form.requestedEnd) }}</dd>

                    <template v-if="cancelledDays.length">
                        <dt>Cancelled Days</dt>
                        <dd>{{ cancelledDays.map((day) => formatDate(day.date)).join(', ') }}</dd>
                    </template>

                    <dt>Reason</dt>
                    <dd :class="{ 'request-view__muted': !form.reason }">{{ form.reason || 'No reason given' }}</dd>
                </dl>

                <LeaveCreditTiles
                    :title="isAdmin ? 'Employee\'s remaining leave credits' : 'Your remaining leave credits'"
                    :leaves="leaves"
                    :current="form.requestedData && form.requestedData.type"
                />

                <div class="request-view__footer">
                    <Button @click="handleCancel">Close</Button>
                    <template v-if="isAdmin && form._id && form.status === 'pending'">
                        <Button
                            class="request-view__reject"
                            :disabled="rejectButtonReadOnly"
                            :loading="isLoading"
                            @click="handleRequest('rejected')"
                        >
                            Reject
                        </Button>
                        <Button
                            class="request-view__approve"
                            :disabled="approveButtonReadOnly"
                            :loading="isLoading"
                            @click="handleRequest('approved')"
                        >
                            Approve
                        </Button>
                    </template>
                </div>
            </div>
        </Modal>
    </div>
</template>
<script>
import moment from 'moment';
import { getRequestRecordByUserAndAttendanceId, requestProcessV2 } from '@/services/requests.services';
import { timeConversion } from '../../../../../../utility/helper';
import { getLeavesInfo, getLeavesInfoViaAdmin } from '@/services/leave.services';
import { leaveModes } from '@/components/Requests/Dev/Leave/LeaveRequest/utils/helper.ts';
import UserList from '@/components/Users/UserList.vue';
import LeaveCreditTiles from '@/components/Requests/Dev/shared/LeaveCreditTiles.vue';
import {
    formatLeaveType,
    formatStatus,
    getCancelledLeaveDays,
    getLeaveStatus,
} from '@/components/Requests/Dev/shared/tableRender';
export default {
    components: { UserList, LeaveCreditTiles },
    data() {
        return {
            readOnly: false,
            form: {
                createdAt: null,
                reason: '',
                requestedData: null,
            },
            isAdmin: false,
            leaves: {},
            rejectButtonReadOnly: false,
            approveButtonReadOnly: false,
            isLoading: false,
            details: null,
            showModal: false,
            closable: false,
            attendanceId: null,
            userId: null,
            mainRole: localStorage.getItem('mainRole') === 'admin',
            isPending: false,
        };
    },
    computed: {
        cancelledDays() {
            return getCancelledLeaveDays(this.form);
        },
    },
    methods: {
        formatLeaveType,
        formatStatus,
        getLeaveStatus,
        formatDate(date) {
            return date ? moment(date).utc().format('YYYY-MM-DD') : '—';
        },
        formatMode(mode) {
            if (!mode) return '—';
            const found = leaveModes.find((m) => m.value === mode);
            return found ? found.label : mode;
        },
        getStatusClass(status) {
            const data = {
                pending: 'warning',
                rejected: 'danger',
                approved: 'success',
            };
            return `statusLabel ${data[status]}`;
        },
        leaveModes() {
            return leaveModes;
        },
        async getSelfLeaveInfo() {
            const { data } = await getLeavesInfo();
            this.leaves = {
                sl: data['remaining-sick-leave'],
                al: data['remaining-appreciation-leave'],
                vl: data['remaining-vacation-leave'],
            };
        },
        getDateOnly(datetime) {
            return moment(datetime).format('yyyy-MM-DD');
        },
        getDaysDifference(from, to) {
            const days = Math.abs(moment(from).startOf('day').diff(moment(to).endOf('day'), 'days'));
            return days + 1;
        },
        onDateStartChange(date) {
            this.form.requestedStart = new Date(date);
            if (!date) {
                this.form.requestedStart = '';
            }
            if (!this.form.requestedStart || this.form.requestedStart > this.form.requestedEnd) {
                this.form.endDate = new Date(date);
            }
        },
        onDateEndChange(date) {
            if (!date) {
                this.form.requestedEnd = '';
            } else {
                if (!this.form.requestedStart || this.form.requestedStart > this.form.requestedEnd) {
                    this.form.requestedStart = new Date(date);
                }
                this.form.requestedEnd = new Date(date);
            }
        },
        async handleGetRequestRecordByAttendanceId(data) {
            return await getRequestRecordByUserAndAttendanceId(this.attendanceId, this.userId, {
                requestedStart: timeConversion(moment.utc(data.createdAt).format('DD-MMM-YYYY'), '00:00'),
            });
        },
        async openModal(data) {
            console.log('data2: ', data);
            this.userId = data.user._id;
            this.form = {
                ...data,
                requestedStart: new Date(data.requestedStart),
                requestedEnd: new Date(data.requestedEnd),
            };
            this.isPending = data.status === 'pending';
            this.showModal = true;
        },

        handleStatusLabel(data) {
            const status = data.status;
            let label = '',
                className = 'statusLabel';
            const upperCaseStats = status.toString().toUpperCase();
            switch (status.toString().trim()) {
                case 'pending':
                    label = upperCaseStats;
                    className = `${className} warning`;
                    break;
                case 'rejected':
                    label = upperCaseStats;
                    className = `${className} danger`;
                    break;
                case 'approved':
                    label = upperCaseStats;
                    className = `${className} success`;
                    break;

                default:
                    break;
            }
            return { label, className };
        },

        handleCancel() {
            this.showModal = false;
        },

        handleConfirm() {
            this.showModal = false;
        },
        handleReset() {
            this.showModal = false;
        },

        async openModalForReadOnly(data) {
            await this.getSelfLeaveInfo();
            this.userId = data.user._id;
            this.form = {
                ...data,
                requestedStart: new Date(data.requestedStart),
                requestedEnd: new Date(data.requestedEnd),
            };
            this.isPending = data.status === 'pending';
            this.showModal = true;
            this.isAdmin = false;
            this.readOnly = true;
        },

        async openModalForAdmin(data) {
            this.userId = data.user._id;
            await this.getEmployeeCreditByAdmin();
            console.log('openModalForAdmin: ', data);
            this.form = {
                ...data,
                requestedStart: new Date(data.requestedStart),
                requestedEnd: new Date(data.requestedEnd),
            };
            // this.form.requestedData.type = 'vl';
            this.isPending = data.status === 'pending';
            this.showModal = true;
            this.readOnly = true;
            this.approveButtonReadOnly = false;
            this.rejectButtonReadOnly = false;
            this.isAdmin = true;
        },

        async getEmployeeCreditByAdmin() {
            const { data: leaves } = await getLeavesInfoViaAdmin(this.userId);
            this.leaves = {
                sl: leaves['remaining-sick-leave'],
                al: leaves['remaining-appreciation-leave'],
                vl: leaves['remaining-vacation-leave'],
            };
        },

        handleRequest(status) {
            this.isLoading = true;
            const data = {
                id: this.form._id,
                status: status,
            };
            requestProcessV2(data)
                .then(() => {
                    this.$Message.success(`Request has been ${status}`);
                    this.isLoading = false;
                    this.$emit('create');
                    this.showModal = false;
                })
                .catch((err) => {
                    if (err.data.statusCode === 400 && err.data.message === 'request not found') {
                        this.$Message.error('Request not found');
                    } else if (err.data.statusCode === 403 && err.data.message === 'request already processed') {
                        this.$Message.error(
                            'You`ve already processed this request time dispute. Please do check it again.'
                        );
                    } else {
                        this.$Message.error('Failed to process request time dispute');
                    }
                    this.isLoading = false;
                });
        },
    },
};
</script>
<style>
.viewTimeDispute .ivu-modal-body {
    padding: 16px;
}
.viewTimeDispute .ivu-modal-footer {
    display: none;
}
.viewTimeDispute .ivu-spin-main {
    justify-content: center;
    display: flex;
}
.viewTimeDispute button {
    font-weight: bold;
    margin-left: 10px;
}
.statusLabel {
    display: inline-block;
    color: #fff;
    border-radius: 5px;
    box-shadow: 0 0 5px -1px rgba(0, 0, 0, 0.2);
    vertical-align: middle;
    max-width: 250px;
    padding: 5px;
    text-align: center;
}
.success {
    background: #49e97e;
    font-weight: bold;
}
.warning {
    background: #ffc107;
    font-weight: bold;
}
.danger {
    background: #e9495d;
    font-weight: bold;
}
</style>

<style lang="scss" scoped>
@import '../../shared/request-view';
</style>
